import React, { useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './BuyerFilterPage.css';

const BuyerFilterPage = () => {
  const [filters, setFilters] = useState({
    allBuyers: false,
    gccBuyers: false
  });

  const handleFilterChange = (filterName) => {
    setFilters(prev => ({
      ...prev,
      [filterName]: !prev[filterName]
    }));
  };

  const CheckboxIcon = ({ checked }) => (
    <svg 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" 
        stroke="#6D6D6D" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      {checked && (
        <path 
          d="M16.668 8.5L9.79297 15.5L6.66797 12.3182" 
          stroke="#6D6D6D" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      )}
    </svg>
  );

  return (
    <div className="buyer-filter-page">
      <Header />
      
      <main className="buyer-filter-main">
        <div className="buyer-filter-card">
          {/* All Buyers Option */}
          <div className="filter-option">
            <label className="filter-checkbox">
              <input 
                type="checkbox" 
                checked={filters.allBuyers}
                onChange={() => handleFilterChange('allBuyers')}
              />
              <span className="checkbox-icon">
                <CheckboxIcon checked={filters.allBuyers} />
              </span>
            </label>
            <span className="filter-label">(All Buyers)</span>
          </div>

          {/* GCC Buyers Option */}
          <div className="filter-option">
            <label className="filter-checkbox">
              <input 
                type="checkbox" 
                checked={filters.gccBuyers}
                onChange={() => handleFilterChange('gccBuyers')}
              />
              <span className="checkbox-icon">
                <CheckboxIcon checked={filters.gccBuyers} />
              </span>
            </label>
            <span className="filter-label">(GCC Buyers)</span>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default BuyerFilterPage;
